const state = {
  fetchUrl: '',
  fileExtension: '.json',
  lang: '',
  country: '',
  fileHash: '',
  translations: {},
};

export default state;
